// @ts-nocheck
/* eslint-disable */

Object.defineProperty(exports, '__esModule', {
  value: true
});
Object.defineProperty(exports, 'Icon', {
  enumerable: true,
  get: function get() {
    return _Icon.Icon;
  }
});

var _Icon = require('./Icon');


